<template>
  <div v-if="startCountdown" class="checkout-summary__countdown">
    <div class="checkout-summary__countdown-container">
      <FontAwesomeIcon :icon="['far', 'clock']" class="text-sm" />

      <p class="checkout-summary__countdown-text">
        {{ $t('landingpage.checkout-page.countdown.reservation-time') }}
      </p>

      <div class="checkout-summary__countdown-counter">
        <div class="checkout-summary__countdown-countdown">
          {{ formattedTime }}
        </div>
        {{ $t('landingpage.checkout-page.countdown.minutes') }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onUnmounted } from 'vue'
import { differenceInMilliseconds, isValid, parseISO } from 'date-fns'

const props = defineProps({
  timeEnd: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['time-expired'])

const formattedTime = computed(() => {
  const totalSeconds = Math.floor(remainingMs.value / 1000)
  const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, '0')
  const seconds = String(totalSeconds % 60).padStart(2, '0')
  return `${minutes}:${seconds}`
})

const startCountdown = ref(false)
const remainingMs = ref(0)
let timer = null

const calculateRemaining = () => {
  // Parse and validate the end time
  const endTime = parseISO(props.timeEnd)

  if (!isValid(endTime)) {
    // eslint-disable-next-line no-console
    console.log('Invalid end time provided to countdown')
    clearInterval(timer)
    return
  }
  // Calculate remaining milliseconds
  remainingMs.value = Math.max(differenceInMilliseconds(endTime, new Date()), 0)

  if (remainingMs.value === 0) {
    clearInterval(timer)
    emit('time-expired')
  }
}

const initCountdown = () => {
  if (!props.timeEnd) {
    // eslint-disable-next-line no-console
    console.log('No end time provided, countdown not initialized')
    return
  }

  startCountdown.value = true

  calculateRemaining()
  timer = setInterval(calculateRemaining, 1000)
}

defineExpose({
  initCountdown,
})

onUnmounted(() => {
  clearInterval(timer)
})
</script>
